import * as tslib_1 from "tslib";
import React, { useRef } from 'react';
import { useTransition, animated } from 'react-spring';
import NotificationSwipeableWrapper from '../NotificationSwipeableWrapper';
import NotificationContent from '../NotificationContent';
import { getNotificationKey } from '../../helpers';
import s from '../../Notifications.scss';
import styleVars from '../../../styles/variables.scss';
var MobileNotificationAnimator = function (_a) {
    var queue = _a.queue, notificationProps = _a.notificationProps;
    var swipeDirectionRef = useRef(null);
    var notificationHeight = styleVars['system-notification-mobile-height'];
    var transitionOptions = {
        unique: true,
        reset: true,
        config: {
            duration: 200,
        },
        from: {
            opacity: 0,
            transform: "translate3d(0%, " + notificationHeight + ", 0)",
        },
        enter: {
            opacity: 1,
            transform: 'translate3d(0%, 0px, 0)',
        },
        leave: function () {
            var swipeDirection = swipeDirectionRef.current;
            swipeDirectionRef.current = null; // clear swipe direction reference data
            return {
                opacity: 0,
                transform: swipeDirection
                    ? swipeDirection === 'Left'
                        ? "translate3d(-100%, 0px, 0)" // user swiped left
                        : "translate3d(100%, 0px, 0)" // user swiped right
                    : "translate3d(0%, " + notificationHeight + ", 0)",
            };
        },
    };
    var transitions = useTransition(queue.slice(0, 1), getNotificationKey, transitionOptions);
    var onSwiped = function (direction, item) {
        swipeDirectionRef.current = direction; // save swiped direction so react-spring can use it
        notificationProps.removeNotification(item.id); // trigger early notification dismissal
    };
    return (React.createElement(React.Fragment, null, transitions.map(function (_a) {
        var style = _a.props, key = _a.key, item = _a.item;
        return (React.createElement(animated.div, { key: key, className: s['animator'], style: style },
            React.createElement(NotificationSwipeableWrapper, { item: item, onSwiped: onSwiped },
                React.createElement(NotificationContent, tslib_1.__assign({ notification: item }, notificationProps)))));
    })));
};
MobileNotificationAnimator.displayName = 'MobileNotificationAnimator';
export default MobileNotificationAnimator;
//# sourceMappingURL=MobileNotificationAnimator.js.map